import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "albums-list" }
const _hoisted_2 = {
  key: 1,
  class: "album__image album__image--placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XImg = _resolveComponent("XImg")!
  const _component_ImageMultipleIcon = _resolveComponent("ImageMultipleIcon")!
  const _component_NcListItem = _resolveComponent("NcListItem")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.albums, (album) => {
      return (_openBlock(), _createBlock(_component_NcListItem, {
        class: "album",
        key: album.album_id,
        name: album.name,
        "aria-label": album.name,
        to: _ctx.link ? _ctx.linkTarget(album) : undefined,
        exact: true,
        onClick: ($event: any) => (_ctx.click($event, album))
      }, {
        icon: _withCtx(() => [
          (_ctx.toCoverUrl(album))
            ? (_openBlock(), _createBlock(_component_XImg, {
                key: 0,
                class: "album__image",
                src: _ctx.toCoverUrl(album)
              }, null, 8, ["src"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_ImageMultipleIcon, { size: 32 })
              ]))
        ]),
        subname: _withCtx(() => [
          _createElementVNode("div", null, _toDisplayString(_ctx.getSubtitle(album)), 1)
        ]),
        extra: _withCtx(() => [
          _renderSlot(_ctx.$slots, "extra", { album: album }, undefined, true)
        ]),
        _: 2
      }, 1032, ["name", "aria-label", "to", "onClick"]))
    }), 128))
  ]))
}